/**
 * @generated SignedSource<<55de30bbd96ff6e7c245566140be81bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServicePageQuery$variables = {
  ujId: number;
};
export type selfServicePageQuery$data = {
  readonly userJourney: {
    readonly isSelfService: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment" | "selfServiceStatus_statusFragment">;
  };
};
export type selfServicePageQuery = {
  response: selfServicePageQuery$data;
  variables: selfServicePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ujId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ujId",
    "variableName": "ujId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSelfService",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServicePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourney",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "selfServiceSettings_mainSettingsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "selfServiceStatus_statusFragment"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selfServicePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourney",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cutoff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cutOffOK",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alertOnSlow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingDomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingDomainLocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeJourneyType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ee35f4e7807b5737da371f8a6286ecf",
    "id": null,
    "metadata": {},
    "name": "selfServicePageQuery",
    "operationKind": "query",
    "text": "query selfServicePageQuery(\n  $ujId: Int!\n) {\n  userJourney(ujId: $ujId) {\n    ...selfServiceSettings_mainSettingsFragment\n    ...selfServiceStatus_statusFragment\n    isSelfService\n    id\n  }\n}\n\nfragment selfServiceSettings_mainSettingsFragment on UserJourney {\n  id\n  name\n  cutoff\n  cutOffOK\n  alertOnSlow\n  journeyScribeStartingDomain\n  journeyScribeStartingDomainLocked\n  journeyScribeJourneyType\n}\n\nfragment selfServiceStatus_statusFragment on UserJourney {\n  id\n  status\n}\n"
  }
};
})();

(node as any).hash = "a58aaa8652cdc59aa38cb7432750c846";

export default node;
